import { connect } from "react-redux";
import React, {useCallback, useEffect, useState} from 'react'
import Table from "../Components/Table/Table";
import {Link} from "react-router-dom";
import {Api} from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import {useNavigate, useParams} from "react-router-dom";
import Popup from "../Components/PopUp/Popup";
import { jsPDF } from "jspdf";
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import Engagement from "../../main/templates/Engagement-Regular.ttf";
import Caveat from "../../main/templates/Caveat-VariableFont_wght.ttf";
import DancingScript from "../../main/templates/DancingScript-VariableFont_wght.ttf";
import BookAntiqua from "../../main/templates/Book-Antiqua.ttf";
import Calibri from "../../main/templates/calibri.ttf";
import Times from "../../main/templates/times.ttf";

const Reportconfig = {   
    url: "certificates",
    name: "Report",
    columns: [
        { name: "Name", key: "name" },
        { name: "Total Certificate", key: "template_count"},
        { name: "Actions", key: "actions" },
    ]
}

const CertificateReport = ({user, ...props}) =>{
    let zip = new JSZip();
    let img = null;

    const params = {path: 'templates'};
    const navigate = useNavigate();
    let config = Reportconfig;
    const [state, setState] = useState({
        loading: true,
        error: null,
        config: config,
        page: 1,
        limit: 10,
        total: 10,
        show: false,
    });

    const [posts, setPosts] = useState([]);
    const [certificateData, setCertificateData] = useState([]);
    const [total, setTotal] = useState(10); 

    const loadData = useCallback(() => {
        setState(s => {
            return {...s, loading: true}
        });
        let start = 0;
        const limit = state.limit;
        const page = state.page;
        start = (page - 1) * limit;
        console.log(start);
        Api.call(`/getCertificateTemplate?limit=${limit}&skip=${start}`).then(response => {
            setTotal(Number(Object.keys(response[response.length-1])[0]));
            response.pop(response.length-1)
            setPosts(response);
        }).catch(console.log).finally(_ => {
            setState(s => {
                return {...s, loading: false}
            });
        });
    }, [config.url, state.page, state.limit]);

    const onPaginate = (page) => {
        setState({...state, page: page, loading: true})
    };

    useEffect(() => {
        if (!user) {
            return;
        }
        loadData()
    }, [loadData, params.path, user]);

    const parsePatient = (post) => {
        let row = state.config.columns.map((column) => {
            if (column.accessor) {
                return column.accessor(post);
            }
            return post[column.key];
        });
        return row;
    };

    const renderRow = (row, index) => {
        let columnIndex = 0;
        let patient = parsePatient(row);
        return <tr key={index}>
            {patient.map(column => {
                return renderColumn(column, columnIndex++, index, patient, row);
            })}</tr>
    };

    const selectAll = () => {
        let allSelected = !state.allSelected;
        let row = state.row.map(patient => {
            patient.selected = allSelected;
            return patient;
        });
        setState({...state, row: row, allSelected: allSelected});
    };

    const onDelete = (event, index) => {
        event.preventDefault();
        if (!window.confirm('Are you sure you want to delete this item?')) {
            return;
        }
        let post = posts[index];
        Api.call(`/${config.url}/${post.Id}`, "DELETE").then(response => {
            loadData();
        })
    };

    const onUp = (event, index) => {
        event.preventDefault();
        setState({...state, loading: true})
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/up`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const onDown = (event, index) => {
        setState({...state, loading: true})
        event.preventDefault();

        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/down`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const DownloadCertificate = (Id) =>{
        Api.call(`/${config.url}?template=${Id}&_sort=id:DESC&_limit=${-1}&_start=${0}`).then(response => {
            setCertificateData(response)    
        }).catch(console.log).finally(_ => {
           
        });   
    };

    const getBase64 = async(file) =>{
        try {
            const response = await fetch(file);
            console.log(response);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise((resolve, reject) => {
                reader.onloadend = () => {
                    console.log(reader.result)
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };
                reader.onerror = reject;
            });
        } catch (error) {
            console.error('Error fetching font:', error);
            throw error;
        }
    }

    const addFont = async(pdf) =>{
        let base64 = await getBase64(Engagement);
        pdf.addFileToVFS('./fonts/Engagement-Regular.ttf', atob(base64));
        pdf.addFont("./fonts/Engagement-Regular.ttf","Engagement","normal");

        let base6 = await getBase64(Caveat);
        pdf.addFileToVFS('./fonts/Caveat-Regular.ttf', atob(base6));
        pdf.addFont("./fonts/Caveat-Regular.ttf","Caveat","normal");

        let base = await getBase64(DancingScript);
        pdf.addFileToVFS('./fonts/DancingScript-Regular.ttf', atob(base));
        pdf.addFont("./fonts/DancingScript-Regular.ttf","DancingScript","normal");
        
        let bas = await getBase64(BookAntiqua);
        pdf.addFileToVFS('./fonts/Book-Antiqua.ttf', atob(bas));
        pdf.addFont("./fonts/Book-Antiqua.ttf","BookAntiqua","normal");

        let ba = await getBase64(Calibri);
        pdf.addFileToVFS('./fonts/calibri.ttf', atob(ba));
        pdf.addFont("./fonts/calibri.ttf","Calibri","normal");

        let b = await getBase64(Times);
        pdf.addFileToVFS('./fonts/times.ttf', atob(b));
        pdf.addFont("./fonts/times.ttf","Times","normal");
    }

    useEffect(()=>{
        if(certificateData.length != 0){
            Download(0);
        }
    },[certificateData])

    const download = async(d, count) => {

        let data = d?.templateData;
        
        var pdf = new jsPDF('l', 'px', [500, 800]);
        await addFont(pdf);
        pdf?.addImage(data?.backgroundImageUrl.replace("itmatic.io", "codebrigade.in"), 'JPEG', 0, 0, 800, 500, '','FAST');

        {
            data?.images?.length !== 0 && data?.images?.map((text, index) => {
                pdf?.addImage(text?.url?.replace("itmatic.io", "codebrigade.in"), 'JPEG',
                    text?.x*1.27,
                    text?.y*0.264583+(text?.y-20),
                    text?.width,
                     text?.height, '','FAST');
            });
        }

        if (data?.qrCode !== null) {
            let qrUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=50x50&data=https://events.chitkara.edu.in/certificate/' + d.id;
            let x = !data.qrCode.x ? 0 : data.qrCode?.x * 1.228;
            let y = !data.qrCode.y ? 0 : data.qrCode?.y * 1.12;
            pdf?.addImage(qrUrl, 'JPEG', x, y, 60, 60);
        }

        data?.label?.map((text) => {
            const size = text.fontSize / 0.75; // convert pixels to points
            pdf?.setFontSize(size);
            pdf?.setTextColor(text?.color);
            pdf.setFont(text.fontFamily);
            if (text?.align === "center") {
                let x = ((text.x * 1.25) + (text.width / 1.7));
                pdf?.text(`${d.data[text.text]}`, x, text?.y * 1.11, {
                    baseline: 'top',
                    color: text?.color,
                    maxWidth: text?.width,
                    align: 'center',
                });
            }
            else {
                let x = text?.x * 1.25;
                pdf?.setFontSize(size);
                pdf?.setTextColor(text?.color);
                pdf.setFont(text.fontFamily);
                pdf?.text(`${d.data[text.text]}`, x, text?.y * 1.11, {
                    baseline: 'top',
                    color: text?.color,
                    maxWidth: text?.width,
                    align: 'left'
                });
            }
        });

        data?.Text?.map((text) => {
            const size = text.fontSize / 0.75; // convert pixels to points
            pdf?.setFontSize(size);
            pdf?.setTextColor(text?.color);
            pdf.setFont(text.fontFamily);
            if (text?.align === "center") {
                let x = ((text.x * 1.25) + (text.width / 1.7));
                pdf?.text(`${text.text}`, x, text?.y * 1.11, {
                    baseline: 'top',
                    color: text?.color,
                    maxWidth: text?.width,
                    align: 'center',
                });
            }
            else {
                let x = text?.x * 1.25;
                pdf?.setFontSize(size);
                pdf?.setTextColor(text?.color);
                pdf.setFont(text.fontFamily);
                pdf?.text(`${text.text}`, x, text?.y * 1.11, {
                    baseline: 'top',
                    color: text?.color,
                    maxWidth: text?.width,
                    align: 'left'
                });
            }
        });

        if(img){
            img.file(`${d.data?.name || d.data?.Name || d.data[Object.keys(data)[1]]}(${d.id}).pdf`, pdf.output("blob"), {base64: true});
        }
        // pdf.save(`${d.data?.name || d.data?.Name}.pdf`);
        setTimeout(() => {
            Download(count + 1);
        }, 1000)
    }

    const Download = (length) => {
        if(img === null){
            img = zip.folder(`Certificate`);
        }
        console.log(length + 1);
        document.getElementsByClassName("Download_Cert")[0].innerText = `${length + 1}/${certificateData.length}`;
        if (certificateData.length == length) {
            zip.generateAsync({type:"blob"}).then(function(content) {
                saveAs(content,`${certificateData[0].template?.name}.zip`);
            });
            img = null;
            zip = new JSZip();
            document.getElementsByClassName("Download_Cert")[0].innerText = `Download Certificate`;
            setCertificateData([]);
            return;
        }
        else {
            download(certificateData[length], length);
        }
    };

    const renderColumn = (column, index, rowIndex, row, originalRow) => {
        if (index === row.length - 1) {

            if (state.config.renderActions) {
                return state.config.renderActions(column, index, rowIndex, row, originalRow, onUp , onDown,onDelete, state, config);
            } else {
                return <td key={index}>
                    <ul>
                        <li>
                            <Link to={`#`} onClick={()=>{DownloadCertificate(originalRow.Id,rowIndex)}}>
                            {columnConfig.downloadIcon}   
                            </Link>
                        </li>
                    </ul>
                </td>
            }
        }
        if (typeof column === "boolean") {
            return <td key={index}><span style={{color: column ? "green" : "red"}}>{column ? "Yes" : "No"}</span></td>
        }
        console.log("Rendering ", column)
        return <td key={index}>{column}</td>
    };
    const renderHeaderColumn = (column, index) => {

        return (
            <th key={index}>
                {column.name}
            </th>
        );
    };

    const searchFunction = (name) => {
        if(name && name.trim() !== ""){
            setState(s => {
                return {...s, loading: true}
            });
            let start = 0;
            const limit = state.limit;
            const page = state.page;
            start = (page - 1) * limit;
            Api.call(`/getCertificateTemplate?limit=${limit}&skip=${start}&name=${name}`)
            .then(response => {
                setTotal(Number(Object.keys(response[response.length-1])[0]));
                response.pop(response.length-1)
                setPosts(response);
            }).catch(console.log).finally(_ => {
                setState(s => {
                    return {...s, loading: false}
                });
            });
        }
        else{
            loadData();
        }
    }

    return <div className="right_container">
    {/* <Popup okBtn={true} trigger={state.showSearch} setSearch={showSearchbox} heading={<div className='search'><h5 className="search-title">Filter</h5>
        <p>Please search here by fields name.</p></div>}>
        <SearchUI filterBuilder={filterBuilder} data={filterData} setData={setFilterData} name="certificates"></SearchUI>
    </Popup> */}
    <div className="dashboard">
        <div className='inner-content'>
        {/* Button={{ callbackfunction: () => { DownloadCertificate(0) } }} */}
        {/* setSearchBox={showSearchbox} */}
            <Heading total={total} searchInput={true} searchFunction={searchFunction} name={config.name} onRefresh={loadData} refreshlink="#" />
            <h4 className="Download_Cert">Download Certificate</h4>
            <div className='commen-table'>
                <Table renderColumn={renderColumn} loading={state.loading}
                    renderRow={renderRow} renderHeaderColumn={renderHeaderColumn} 
                    currentPage={state.page} perPage={state.limit} columns={state.config.columns} 
                    cardFooter="cardFooter" total={total} rows={posts}
                    selected="Invite Selected" onPaginate={onPaginate}
                    onChangePerPage={(limit) => {
                        setState({ ...state, limit });
                    }}
                />
            </div>
        </div>
    </div>
</div>
}
const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CertificateReport);
